import { campaign, CampaignQuery } from './campaign'
import { del, get, patch, post, toQueryString } from '../axios'
import { z } from 'zod'
import { paginated } from '../zod/pagination'
import { StoreInput } from './input/store-input'
import { UpdateInput } from './input/update-input'
import { StoreColumnInput } from './input/store-column-input'
import { ReorderColumnInput } from './input/reorder-column-input'
import { column } from './column'

export function fetchCampaigns({ query }: { query?: CampaignQuery } = {}) {
    return get(paginated(campaign), '/campaigns' + `?${toQueryString(query || {})}`)
}

export function fetchCampaign(campaignId: string) {
    return get(campaign, `/campaigns/${campaignId}`)
}

export function storeCampaign(input: StoreInput) {
    return post(campaign, '/campaigns', input)
}

export const deleteCampaign = (campaignId: string) => {
    return del(campaign, `/campaigns/${campaignId}`)
}

export function updateCampaign(campaignId: string, input: UpdateInput) {
    return patch(campaign, `/campaigns/${campaignId}`, input)
}

export function storeCampaignColumn(campaignId: string) {
    return (input: StoreColumnInput) => post(column, `/campaigns/${campaignId}/columns`, input)
}

export function deleteCampaignColumn(campaignId: string, columnId: string) {
    return del(column, `/campaigns/${campaignId}/columns/${columnId}`)
}

export function updateCampaignColumn(campaignId: string, columnId?: string) {
    return (input: StoreColumnInput) => patch(column, `/campaigns/${campaignId}/columns/${columnId}`, input)
}

export function reorderCampaignColumns(campaignId: string) {
    return (input: ReorderColumnInput) => patch(column.array(), `/campaigns/${campaignId}/columns/reorder`, input)
}

export function sortColumnCandidates(campaignId: string, columnId: string) {
    return (input: { sortBy: string; direction: string }) =>
        patch(z.string(), `/campaigns/${campaignId}/columns/${columnId}/sort`, input)
}
